import { AgentPromptDocumentTab } from "@/features/agents/agent-prompt-document-tab";
import { AGENT_SOUL_PROMPT_KEY } from "@/lib/types/control-plane-agents";

export function AgentPersonaTab() {
  return (
    <AgentPromptDocumentTab
      tabId="persona"
      promptKey={AGENT_SOUL_PROMPT_KEY}
      title="SOUL.md"
      placeholder="Write the agent identity and persona markdown..."
    />
  );
}
